import { defineStore } from "pinia"
import moment from "@/utils/moment"
import {CalendarViews} from "@/enums/calendarViews"
import {ref, computed, watch} from "vue"

export const useCalendarStore = defineStore("calendar", () => {
  const showCalendarSelect = ref(false)
  const selectedYear = computed(() => moment(calendarStart.value).year())
  const selectedMonth = computed(() => moment(calendarStart.value).month())
  const selectedWeek = computed(() => moment(calendarStart.value).week())
  const selectedDay = computed(() => moment(calendarStart.value).day())


  const defaultStart = moment().startOf('day').toISOString()
  const storedStart = sessionStorage.getItem('calendarStart')
  const calendarStart = ref(storedStart ?? defaultStart)
  watch(calendarStart, (val) => {
    sessionStorage.setItem('calendarStart', val)
  })



  const storedView = localStorage.getItem('calendarView') as CalendarViews ?? 'month'
  const calendarView = ref<CalendarViews>(storedView)
  watch(calendarView, (val) => {
    localStorage.setItem('calendarView', val)
  })

  const storedHiddenCategories: Record<number, number[]> = JSON.parse(localStorage.getItem('hiddenCategories') || '{}')
  const hiddenCategories = ref<Record<number, number[]>>(storedHiddenCategories)
  watch(hiddenCategories, (val) => {
    localStorage.setItem('hiddenCategories', JSON.stringify(val))
  })

  const setDate = (view: CalendarViews, date: moment.Moment|Date|string) => {
    switch (view) {
      case CalendarViews.YEAR:
        setYear(date)
        break
      case CalendarViews.MONTH:
        setMonth(date)
        break
      case CalendarViews.WEEK:
        setWeek(date)
        break
      case CalendarViews.DAY:
        setDay(date)
        break
    }
  }
  const setMonth = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('month').toISOString()
    calendarView.value = CalendarViews.MONTH
  }
  const setYear = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('year').toISOString()
    calendarView.value = CalendarViews.YEAR
  }
  const setWeek = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).toISOString()
    calendarView.value = CalendarViews.WEEK
  }
  const setDay = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('day').toISOString()
    calendarView.value = CalendarViews.DAY
  }

  return {
    calendarStart,
    calendarView,
    hiddenCategories,
    showCalendarSelect,
    selectedYear,
    selectedMonth,
    selectedWeek,
    selectedDay,
    setDate,
    setMonth,
    setYear,
    setWeek,
    setDay
  }
})
